/**
 * SOLID Review
 * S — Strong. One use case: hear the seated player's pushed balance — or nobody's, when no one is seated.
 * O — Strong. Whose balance to hear is the Domain's decision.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The decisions and watch ports and the session's step, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepPayment } from './IConfigDepPayment';

/** The account watch (FE4c): idempotent at the watch, so StrictMode's double effect subscribes once. */
export class WatchAccountUseCase implements IUseCase<ICommandNothing, TPortOutcome> {
  constructor(private readonly deps: IConfigDepPayment) {}

  async execute(ctx: IContextRequest, command: ICommandNothing): Promise<TPortOutcome> {
    const { decisions, step, watch } = this.deps;
    const target = await step.run(ctx, (input) => decisions.planAccountWatch(ctx, input, command));
    if (!target.success) return target;
    return watch.watchAccount(ctx, target.value);
  }
}
